.app {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	min-width: var(--jpo-common-min-app-width);
	box-sizing: border-box;
	flex: 1 0 auto;
}

body > form {
	/*
    We reset the form margin here as a stylesheet from Jira which we can't touch is adding a 12px margin top to form elements,
    which overrides our own reset and pushes our page down
    */
	margin: 0;
}

.wrapperLoading {
	display: flex;
	overflow: hidden;
	height: 100vh;
	outline: none;
	cursor: grab;
	align-items: center;
	justify-content: center;
}
